export const MODULE = 'EBPLS';
export const LIST = `${MODULE}/list`;
export const ITEM = `${MODULE}/item`;
export const TOGGLE_ASSESSMENT = `${MODULE}/toggle_assessment`;
export const GENERATE_BIN = `${MODULE}/genearate_bin`;
export const GENERATE_PERMIT = `${MODULE}/genearate_permit`;
export const POST_BIN = `${MODULE}/post_bin`;
export const INITIAL_COMPUTATION = `${MODULE}/initial_computation`;
export const UPDATE_FEES = `${MODULE}/update_fees`;
export const CALCULATION = `${MODULE}/calculation`;
export const UPDATE_CALCULATION = `${MODULE}/update_calculation`;
export const SELECTED_CALCULATION = `${MODULE}/selected_calculation`;
export const FINAL_COMPUTATION = `${MODULE}/final_compuntation`;
export const VERIFY = `${MODULE}/verify`;
export const VERIFY_RENEWAL = `${MODULE}/verify_renewal`;
export const APPROVE = `${MODULE}/approve`;
export const APPROVE_ENGR = `${MODULE}/approve_engr`;
export const APPROVE_RENEWAL = `${MODULE}/approve_renewal`;
export const REJECT = `${MODULE}/reject`;
export const RELEASE = `${MODULE}/release`;
export const APPROVE_OWNERSHIP = `${MODULE}/approve_ownership`;
export const FORWARD_TO_LICENSE = `${MODULE}/forward_to_license`;
export const VERIFY_PREVIEW_SOA = `${MODULE}/verify_preview_esoa`;
export const REVERT_APPLICATION = `${MODULE}/revert_application`;
export const GET_FEES_LIST = `${MODULE}/fees_list`;

export const LIST_GROUP = `${MODULE}/list_group`;

export const UPDATE_APPLICATION = `${MODULE}/update_application`;
export const CHANGE_APPLICATION = `${MODULE}/change_application`;
export const GET_BUSINESS_ACTIVITY_LIST = `${MODULE}/get_business_activity_list`;
export const GET_BUSINESS_NATURES_LIST = `${MODULE}/get_business_natures_list`;
export const GET_BUSINESS_LINES_LIST = `${MODULE}/get_business_lines_list`;
export const GET_NECESSARY_FIELD_LIST = `${MODULE}/get_necessary_field_list`;
export const CREATE_BUSINESS_ACTIVITY = `${MODULE}/create_business_activity`;
export const UPDATE_BUSINESS_ACTIVITY = `${MODULE}/update_business_activity`;
export const REMOVE_BUSINESS_ACTIVITY = `${MODULE}/remove_business_activity`;
export const GENERATE_TRANSMITTAL = `${MODULE}/generate_transmittal`;
export const TOGGLE_LICENSE_ASSESSMENT = `${MODULE}/toggle_license_assessment`;
export const GENERATE_ESOA = `${MODULE}/generate_esoa`;
export const GENERATE_ESOA_RENEWAL = `${MODULE}/generate_esoa_renewal`;
export const ADD_BUSINESS_REMARKS = `${MODULE}/add_business_remarks`;
export const UPDATE_CEDULA_AMOUNT = `${MODULE}/update_cedula_amount`;
export const UPDATE_BUSINESS_ACTIVITY_GROSS_AMOUNT = `${MODULE}/update_business_activity_gross_amount`;
export const GET_LOGS = `${MODULE}/get_logs`;
export const UPDATE_DELINQUENT_CALCULATION_DETAIL = `${MODULE}/update_delinquent_calculation_detail`;
export const GET_CODE_LIST = `${MODULE}/get_code_list`;
export const ADD_DELINQUENT_YEAR = `${MODULE}/add_delinquent_year`;
export const CANCEL_SOA = `${MODULE}/cancel_soa`;
export const RETIREMENT_APPLICATION = `${MODULE}/retirement_application`;
export const ASSESS_RETIREMENT_REQUEST = `${MODULE}/assess_retirement_request`;
export const CANCEL_APPLICATION = `${MODULE}/cancel_application`;
export const ASSESS_RENEW_APPLICATION = `${MODULE}/assess_renew_application`;
export const VALIDATE_BUSINESS_ACTIVITY = `${MODULE}/validate_business_activity`;
export const REVOKE_PERMIT = `${MODULE}/revoke_permit`;
export const RETURN_TO_PERMIT = `${MODULE}/return_to_permit`;
export const RECALCULATE_SOA = `${MODULE}/recalculate_soa`;
export const GET_TRANSMITTAL_LIST = `${MODULE}/get_transmittal_list`;
export const INQUIRE_PREVIOUS_OR = `${MODULE}/inquire_previous_or`;
export const UPLOAD_CTC = `${MODULE}/upload_ctc`;
export const GET_BILLING_LIST = `${MODULE}/get_billing_list`;
export const UPDATE_BILLING = `${MODULE}/update_billing`;
export const UPDATE_OR_DATE = `${MODULE}/update_or_date`;
export const PAYMENT_POSTING = `${MODULE}/payment_posting`;
export const UPDATE_BUSINESS_STATE = `${MODULE}/update_business_state`;
export default {};

export const GET_VET_REGISTRATION_LIST =
  'GET_VET_REGISTRATION_LIST/get_vet_registration_list';

export const TRANSMITTAL =
  'api/v1/bpls/administrator/transaction_histories/transmittal/view'; // transmittal
export const EBPLS_E2E_URL =
  'api/v1/ebpls/administrator/transaction_histories/permits/{id}/preview_soa'; // new url
export const EBPLS_E2E_URL_PREVIEW_ESOA =
  'api/v1/ebpls/administrator/transaction_histories/permits/{id}/preview_esoa';
  
export const GET_TRANSACTION_COUNTS = 'TRANSACTION/get_transaction_counts';

export const GET_REGION = `${MODULE}/get_regions`;
export const GET_PROVINCE = `${MODULE}/get_provinces`;
export const GET_MUNICIPALITIES = `${MODULE}/get_municipalities`;
export const GET_BARANGAYS = `${MODULE}/get_barangays`;
export const GET_CITIZENSHIP = `${MODULE}/get_citizenship`;

export const CALLBACK_TIMER = 'CALLBACK_TIMER/callback_timer';

// manual posting
export const MANUAL_PAYMENT_POSTING = 'TRANSACTION/manual_payment_posting';

// unified application form
export const EBPLS_UAF_URL =
  'api/v1/ebpls/administrator/transaction_histories/permits/{id}/preview_uaf';

export const FORM_DATA = {
  name: '',
  kind_of_ownership: '',
  bin: '',
  tin_no: '',
  dti_no: '',
  sec_no: '',
  cellphone_no: '',
  telephone_no: '',
  area_of_business_establishment: '',
  no_of_employees: '',
  taxpayer_id: '',
  region_code: '130000000',
  province_code: '133900000',
  municipality_code: '',
  barangay_code: '',
  street: '',
  capital_amount: '',
  gross_amount: '',
};

export const FORM_DATA_REMARKS = {
  remarks: '',
};

export const KIND_OF_OWNERSHIP = [
  { label: 'SOLE PROPRIETORSHIP', value: 'SOLE PROPRIETORSHIP' },
  { label: 'ONE PERSON CORPORATION', value: 'ONE PERSON CORPORATION' },
  { label: 'PARTNERSHIP', value: 'PARTNERSHIP' },
  { label: 'CORPORATION', value: 'CORPORATION' },
  { label: 'COOPERATIVE', value: 'COOPERATIVE' },
];

export const OWNERS_GENDER = [
  { label: '', value: '' },
  { label: 'Male', value: 'M' },
  { label: 'Female', value: 'F' },
];

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const ANNUAL_INSPECTION_FEE_LIST = [
  { label: 'BUILDING INSPECTION FEE', value:'BUILDING INSPECTION FEE' },
  { label: 'ELECTRICAL INSPECTION FEE', value:'ELECTRICAL INSPECTION FEE' },
  { label: 'MECHANICAL INSPECTION FEE', value:'MECHANICAL INSPECTION FEE' },
  { label: 'PLUMBING INSPECTION FEE', value:'PLUMBING INSPECTION FEE' },
  { label: 'ELECTRONICS INSPECTION FEE', value:'ELECTRONICS INSPECTION FEE' },
  { label: 'SIGNBOARD/BILLBOARD RENEWAL FEE', value:'SIGNBOARD/BILLBOARD RENEWAL FEE' },
  { label: 'OTHERS', value:'OTHERS '}
]
